import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';

import firebase from 'firebase/app';
import '@firebase/auth';
import '@firebase/firestore';

import VueFirestore from 'vue-firestore'

import store from './store';

firebase.initializeApp({
    apiKey: "AIzaSyAe0jss9txD21_opg_UCmzC1z3-oUW88eI",
    authDomain: "meinenewdashboard.firebaseapp.com",
    databaseURL: "https://meinenewdashboard.firebaseio.com",
    projectId: "meinenewdashboard",
    storageBucket: "meinenewdashboard.appspot.com",
    messagingSenderId: "874520683846",
    appId: "1:874520683846:web:41cf2ca61c26807df77147",
    measurementId: "G-FHFJSYC1VF"
});
firebase.firestore().settings({
    cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
});
if ((navigator.appVersion.includes("iPhone")) || (navigator.appVersion.includes("iPad"))) {
    console.warn("No offline cache available due to bug in safari! https://bugs.webkit.org/show_bug.cgi?id=226547#c0");
} else {
    firebase.firestore().enablePersistence({synchronizeTabs: true}).catch(error => {
        if (error.code == 'failed-precondition') {
            // Multiple tabs open, persistence can only be enabled
            // in one tab at a a time.
            // ...
        } else if (error.code == 'unimplemented') {
            // The current browser does not support all of the
            // features required to enable persistence
            // ...
        }
    })
}
Vue.use(VueFirestore)

Vue.config.productionTip = false
Vue.config.devtools = false

if(process.env.NODE_ENV === "development") {
    loginNew.loginNewUrl = process.env.VUE_APP_LOGIN_NEW_URL
}
var host = `${location.protocol}//${location.host}/`;
loginNew.init("meinenewdash", host, [
    "google_analytics"
], "openid profile email new_cookie apps categories");

const tracker = {
    configure() {
        if(loginNew.serviceAllowed("google_analytics")) {
            if(loginNew.isSignedIn()) {
                gtag('config', 'UA-71877411-2', {
                    "user_id": loginNew.getProfile().sub
                });
            }else{
                gtag('config', 'UA-71877411-2');
            }
        }
    },
    trackEvent(category, action, label) {
        if(loginNew.serviceAllowed("google_analytics")) {
            gtag('event', action, {
                'event_category': category,
                'event_label': label,
            });
        }
    }
};

export {firebase, tracker};

new Vue({
    vuetify,
    router,
    store,
	render: function (h) {
		return h(App)
	}
}).$mount('#app')